exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-4249803a] *{max-width:100%}[data-v-4249803a] canvas.drawingBuffer{position:fixed;right:-100vw}", ""]);

